export default __webpack_public_path__ + "big-img-desktop-large-e4596ff8f82105992c1aba938dea8028.png";